import React, { CSSProperties, ReactNode } from 'react'
import './InfoContainer.css';
import cn from 'classnames'

export type InfoRow = {
  title?: string | ReactNode,
  content: string | ReactNode
}

export type InfoContainerProps = {
  rows: InfoRow[],
  className?: string
  contentFontColor?: "base" | "secondary" | "tertiary" | "black"
  contentFontSize?: "tiny" | "small" | "medium" | "large"
  seeMoreCb?: Function
  testId?: string
  seeMoreTestId?: string,
  count?: string | number | React.ReactNode,
}

const InfoContainter = (props: InfoContainerProps) => {

  const {
    contentFontColor = "black",
    contentFontSize = "large",
    testId = "cs-infocontainer",
    seeMoreTestId = "cs-infocontainer-see-more"
  } = props;

  const InfoRowContentClassNames = cn('InfoRowContent', {
    [`InfoRowContent--tiny`]: contentFontSize === 'tiny',
    [`InfoRowContent--small`]: contentFontSize === 'small',
    [`InfoRowContent--medium`]: contentFontSize === 'medium',
    [`InfoRowContent--secondary`]: contentFontColor === 'secondary',
    [`InfoRowContent--tertiary`]: contentFontColor === 'tertiary',
    [`InfoRowContent--base`]: contentFontColor === 'base',
  })

  const seeMoreClick = () => {
    props.seeMoreCb();
  }

  return (
    <div className={"InfoContainer"}>
      {props.rows?.map((infoRow, index) => (
        <div className={"InfoRow"} key={index}>
          {infoRow.title && <div className="InfoRowTitle">{infoRow.title}</div>}
          <div className={InfoRowContentClassNames}>{infoRow.content ? infoRow.content : '-'}</div>
        </div>
      ))}
      {
        props.seeMoreCb &&
        <div onClick={seeMoreClick} className="InfoSeeMore" data-test-id={seeMoreTestId}>{`See All (${props?.count ? props?.count : props.rows?.length})`}</div>
      }
    </div>
  )
}

export default InfoContainter;